import React from 'react';

export type Theme = 'light' | 'dark';

export interface ThemeContextValue {
    theme: Theme;
    toggleTheme: () => void;
}

export const ThemeContext = React.createContext<ThemeContextValue>({
    theme: 'light',
    toggleTheme: () => { },
});
